import { Link } from "react-router-dom";
import { categories, contactChannels, siteInfo } from "@/mocks/site";

const contentLinks = [
  { name: "年度盘点", path: "/rankings" },
  { name: "TOP 榜", path: "/rankings" },
  { name: "名场面合集", path: "/moments" },
  { name: "补课答疑", path: "/faq" },
];

const aboutLinks = [
  { name: "关于瓜田", path: "/about" },
  { name: "内容原则", path: "/about" },
  { name: "线索征集", path: "/about" },
  { name: "用户口碑", path: "/about" },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-10 pt-14 md:pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="w-10 h-10 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-xl">
                <i className="ri-plant-line" />
              </span>
              <span className="font-heading font-bold text-xl">{siteInfo.name}</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200/80">
              {siteInfo.slogan}。把散落的话题整理成可回顾的目录，理性吃瓜，以公开信息为依据。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="w-9 h-9 rounded-full bg-primary-800/60 flex items-center justify-center text-lg">
                <i className="ri-wechat-line" />
              </span>
              <span className="w-9 h-9 rounded-full bg-primary-800/60 flex items-center justify-center text-lg">
                <i className="ri-weibo-line" />
              </span>
              <span className="w-9 h-9 rounded-full bg-primary-800/60 flex items-center justify-center text-lg">
                <i className="ri-mail-line" />
              </span>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-bold text-base mb-4 text-background-50">内容入口</h4>
            <ul className="space-y-3 text-sm">
              {contentLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-background-200/80 hover:text-accent-300 transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-base mb-4 text-background-50">关于与帮助</h4>
            <ul className="space-y-3 text-sm">
              {aboutLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-background-200/80 hover:text-accent-300 transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-base mb-4 text-background-50">联系方式</h4>
            <ul className="space-y-3 text-sm">
              {contactChannels.map((channel) => (
                <li key={channel.label} className="flex items-start gap-2.5">
                  <span className="w-5 h-5 flex items-center justify-center mt-0.5 text-accent-400 text-base">
                    <i className={channel.icon} />
                  </span>
                  <span className="text-background-200/80">
                    <span className="block text-xs text-background-300/70">{channel.label}</span>
                    {channel.value}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-primary-800/70 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-300/70">
          <p>© {new Date().getFullYear()} {siteInfo.fullName} 保留所有权利</p>
          <p className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1">
            {categories.map((cat) => (
              <span key={cat.slug} className="whitespace-nowrap">
                #{cat.name}
              </span>
            ))}
          </p>
        </div>
      </div>
    </footer>
  );
}